import { useQueryClient } from '@tanstack/react-query'

import { ROBOT_STATUS_KEY } from '@/api/matching-robot'
import {
  CUSTOMER_MANDATES_KEY,
  MANDATE_NAMES_KEY,
  PROPERTIES_KEY,
  SEARCH_MANDATES_KEY,
} from '@/api/query-keys'

/** The invalidations the matching screens share, so a mutation names the
 *  effect ("a match changed") rather than listing query keys. */
export function useInvalidateMatchingQueries() {
  const queryClient = useQueryClient()
  const invalidate = (queryKey: readonly unknown[]) =>
    queryClient.invalidateQueries({ queryKey })

  return {
    invalidateSearchMandates: () => invalidate(SEARCH_MANDATES_KEY),

    /**
     * After mandate data came back from HubSpot: the mandates and the name
     * roster the pickers read, which the refreshed record may rename.
     */
    invalidateAfterMandateRefresh: () => {
      invalidate(SEARCH_MANDATES_KEY)
      invalidate(MANDATE_NAMES_KEY)
    },
    invalidateRobotStatus: () => invalidate(ROBOT_STATUS_KEY),
    invalidateCustomerMandates: () => invalidate(CUSTOMER_MANDATES_KEY),

    /**
     * After a match was confirmed, rejected or deleted: the mandate prefix — a
     * mandate's own match list is keyed under it, so the prefix reaches both
     * the list and the counts — and the properties list, which shows matches
     * per property.
     */
    invalidateAfterMatchUpdate: () => {
      invalidate(SEARCH_MANDATES_KEY)
      invalidate(PROPERTIES_KEY)
    },
  }
}
